import { render, staticRenderFns } from "./RdsMedia.vue?vue&type=template&id=24a4d64b&scoped=true&"
import script from "./RdsMedia.vue?vue&type=script&lang=js&"
export * from "./RdsMedia.vue?vue&type=script&lang=js&"
import style0 from "./RdsMedia.vue?vue&type=style&index=0&id=24a4d64b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4d64b",
  null
  
)

export default component.exports